import styles from './styles.module.css';
import { FaFacebookF, FaPhone, FaEnvelope } from "react-icons/fa6";

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { toastOptions } from 'src/constants/toast';
import LangMenu from 'src/components/langMenu/LangMenu';
import { DEFAULT_EMAIL } from 'src/constants/vars';

import { Link as ScrollLink } from "react-scroll";

const Footer = () => {
    const { t } = useTranslation("common");

    const links = [
        { name: t("footer.links.home"), to: "hero" },
        { name: t("footer.links.about"), to: "aboutUs" },
        { name: t("footer.links.services"), to: "services" },
        { name: t("footer.links.whyChooseUs"), to: "whyUs" }
    ];

    const copyToClipBoard = async (copyMe: string) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            return true;
        } catch (err) {
            return false;
        }
    };

    const phoneCopyHandler = async (phoneNumber: string) => {
        const copied = await copyToClipBoard(phoneNumber);
        if (copied) {
            toast.success(t("footer.copied"), toastOptions);
        }
    };

    return (
        <section className={styles.footer}>
            <div className="container">
                <div className="row">

                    {/* LOCATION */}
                    <div className='col-lg-5 col-12 mb-5 mb-lg-0'>
                        <div className={styles.location}>
                            <h4 className={styles.title}>{t("footer.location")}</h4>
                            <div>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3370.0577203514895!2d15.021617399999998!3d32.363997100000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a6b3003803011d%3A0x8db7f013c8745f9d!2z2LTYsdmD2Kkg2KfZhNiv2LHYqCDYp9mE2KPZiNmEINmE2YLYt9i5INi62YrYp9ixINin2YTYtNin2K3Zhtin2Kog2KfZhNi12YrZhtmK2Yc!5e0!3m2!1sar!2sly!4v1766260226692!5m2!1sar!2sly"
                                    height="227"
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title={t("footer.map_title")}
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-1 col-12'></div>

                    {/* LINKS (SCROLL) */}
                    <div className='col-lg-3 col-md-6 col-12 mb-5 mb-lg-0'>
                        <div className={styles.list}>
                            <h4 className={styles.title}>{t("footer.links.title")}</h4>
                            <ul>
                                {links.map((item, index) => (
                                    <li key={`links-key-${index}`}>
                                        <ScrollLink
                                            to={item.to}
                                            smooth={true}
                                            duration={500}
                                            offset={-70}
                                            spy={true}
                                            className={styles.link}
                                        >
                                            {item.name}
                                        </ScrollLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* CONTACT INFO */}
                    <div className='col-12 col-lg-3 col-md-6 mb-5 mb-lg-0'>
                        <div className={styles.list}>
                            <h4 className={styles.title}>{t("footer.contact_info")}</h4>
                            <ul>
                                <li>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218923787927")}>
                                        <FaPhone /> {t("footer.phone1")}
                                    </span>
                                </li>
                                <li>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218912282727")}>
                                        <FaPhone /> {t("footer.phone2")}
                                    </span>
                                </li>

                                <li>
                                    <a className={styles.link} href={`mailto:${DEFAULT_EMAIL}`}>
                                        <FaEnvelope /> {DEFAULT_EMAIL}
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className={styles.link}
                                        href="https://www.facebook.com/share/1GxXXePR8i/?mibextid=wwXIfr"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaFacebookF /> {t("footer.facebook")}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div className={styles.copyright}>
                    <LangMenu />
                    <div>{t("footer.copyright")}</div>
                </div>
            </div>
        </section>
    );
};

export default Footer;
